export default {
//	home: () => { import('./home'); }
	single_post: () => { import( './single-post'); }
};
